import validate from "validate.js";

const errorMessages = {
  is_required: "پر کردن این فیلد اجباریست",
  validation: {
    only_char_fa: "فقط حروف فارسی وارد کنید",
    only_mail: "فرمت پست الکترونیک را صحیح وارد کنید",
    only_phone: "شماره ثابت را صحیح وارد کنید",
    only_mobile: "شماره همراه را صحیح وارد کنید",
    only_pdf: "شما فقط میتوانید فایل PDF انتخاب کنید",
    over_size: "حجم فایل بیشتر از {0} است",
  },
};

const validateFiles = (data, schema) => {
  const schemaWithFiles = {};
  const schemaWithFilesForValidateJs = {};
  const dataWithFiles = {};
  Object.keys(schema).forEach((key) => {
    if (schema[key]?.file) {
      Object.assign(schemaWithFilesForValidateJs, {
        [key]: { presence: schema[key].presence, format: schema[key].format },
      });
      Object.assign(schemaWithFiles, { [key]: schema[key] });
      Object.assign(schemaWithFiles, { [key]: schema[key] });
    }
  });
  Object.keys(data).forEach(
    (key) =>
      Object.keys(schemaWithFiles).includes(key) &&
      Object.assign(dataWithFiles, { [key]: data[key] })
  );

  const errorList =
    validate(dataWithFiles, schemaWithFilesForValidateJs, {
      fullMessages: false,
    }) || {};
  Object.keys(dataWithFiles).forEach((key) => {
    if (
      dataWithFiles[key]?.size &&
      schemaWithFiles[key]?.size &&
      schemaWithFiles[key].size < dataWithFiles[key].size
    ) {
      const createErrorMessage = errorMessages.validation.over_size.replace(
        "{0}",
        (schemaWithFiles[key]?.size / (1024 * 1024)).toFixed(2) + "MB"
      );
      Object.assign(errorList, { [key]: [createErrorMessage] });
    }
  });
  return errorList;
};

function validation(data, schema) {
  const schemaWithoutFiles = {};
  const dataWithoutFiles = {};
  Object.keys(schema).forEach(
    (key) =>
      !schema[key]?.file &&
      Object.assign(schemaWithoutFiles, { [key]: schema[key] })
  );
  Object.keys(data).forEach(
    (key) =>
      Object.keys(schemaWithoutFiles).includes(key) &&
      Object.assign(dataWithoutFiles, { [key]: data[key] })
  );

  const errorList = {};
  Object.assign(
    errorList,
    validate(dataWithoutFiles, schemaWithoutFiles, { fullMessages: false })
  );
  Object.assign(errorList, validateFiles(data, schema));
  return Object.keys(errorList).length > 0 ? errorList : null;
}

export const createSchemaValidation = (element_list) => {
  const createValid = {};
  element_list.forEach(
    (element) => (createValid[element.name] = typeValidation({ ...element }))
  );
  return createValid;
};

export const regex = {
  only_char: "^[\u0600-\u06F0\\s]*$",
  only_email:
    "^$|^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.(?:[a-zA-Z]{2}|com|org|net|edu|gov|mil|biz|info|mobi|name|aero|asia|jobs|museum)$",
  only_mobile: "(^$|^(09|۰۹)([\u06F0-\u06F90-9-0-9]{9})$)*",
  only_phone_number: "^$|^0\\d{2,3}\\d{8}$",
};

const typeValidation = ({ type, isRequired, file_type }) => {
  let list_valid = {};
  if (isRequired) {
    if (!list_valid) {
      list_valid = {};
    }
    list_valid.presence = {
      message: errorMessages.is_required,
      allowEmpty: false,
    };
  }
  switch (type) {
    case "name":
      list_valid.format = {
        pattern: regex.only_char,
        message: errorMessages.validation.only_char_fa,
      };
      break;
    case "mail":
      list_valid.format = {
        pattern: regex.only_email,
        message: errorMessages.validation.only_mail,
      };
      break;
    case "phone":
      list_valid.length = {
        is: 11,
        message: errorMessages.validation.only_phone,
      };
      list_valid.format = {
        pattern: regex.only_mobile,
        message: errorMessages.validation.only_mobile,
      };
      break;
    case "tel":
      list_valid.format = {
        pattern: regex.only_mobile,
        message: errorMessages.validation.only_mobile,
      };
      break;
    case "phone_number":
      list_valid.format = {
        pattern: regex.only_phone_number,
        message: errorMessages.validation.only_phone,
      };
      break;
    case "file":
      list_valid.file = true;
      list_valid.file_type = file_type;
      list_valid.size = 5242880; //byte
      break;
    default:
      break;
  }
  return list_valid;
};

export default validation;
